import React from "react";
import Styles from "./Card.module.css";

export default function Card(props) {

  const checkBranch = v => ({
    "1":"CS Engg","2":"ECE Engg","3":"Civil Engg","4":"Mechanical Engg","5":"Electrical Engg"
  }[v] || "");

  return (
    <div className={Styles.card}>

      {/* Top Profile Area */}
      <div className={Styles.cardTop}>
        <img src={"https://recstudentportal.com/" + props.Photo} alt="" />
        <div className={Styles.userName}>{props.Name}</div>

        <div className={Styles.badges}>
          <div className={Styles.badge}>Level - {props.Level}</div>
          <div className={Styles.badge}>Points - {props.Point}</div>
        </div>
      </div>

      {/* Bottom Info */}
      <div className={Styles.cardBottom}>
        <div className={Styles.title}>{props.title}</div>
        <p className={Styles.desc}>It is a quiz contest conducted by REC Student Portal.</p>
        <p className={Styles.desc}>Rank: <b>{props.Rank}</b></p>

        <div className={Styles.stats}>
          <span>Year: <b>{props.Year}</b></span>
          <span>Round: <b>{props.Round}</b></span>
          <span>Branch: <b>{checkBranch(props.Branch)}</b></span>
          <span>Total Pts: <b>{props.Total}</b></span>
        </div>

        <p style={{marginTop:"12px"}}>
          Congratulations <span className={Styles.cong_name}>{props.Name}</span>
        </p>
      </div>
    </div>
  );
}
